import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Grid, Button } from '@mui/material'
import invitesActions from './actions'
import PreviewTile from 'components/common/PreviewTile'
import Header from 'pages/User/Header'
import PageHeader from 'components/common/PageHeader'
import userActions from '../User/actions'
import { INVITE_BREAK_DOWN } from 'api/InvitesConstants'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

const InvitesOverview = () => {
    const { openCreateDialog } = userActions()
    const [breakdown, setBreakdown] = useState({})

    useEffect(() => {
        fetch(INVITE_BREAK_DOWN)
            .then((response) => response.json())
            .then((data) => {
                setBreakdown(data.data)
            })
    }
    , [])

    return (
        <>
            <PageHeader title="Invites" subTitle="View and manage invites">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => openCreateDialog()}
                    startIcon={<PersonAddAltIcon />}
                >
                    Invite User
                </Button>
            </PageHeader>
            <Grid container justify="flex-start" id="invites-overview" spacing={2}>
                {[
                    {
                        h: 'Active Link Invites',
                        c: breakdown && breakdown.active_link_invites,
                        id: 'active-link-invites',
                    },
                    {
                        h: 'Active Email Invites',
                        c: breakdown && breakdown.active_email_invites,
                        id: 'active-email-invites',
                    },
                    {
                        h: 'Registered Invites',
                        c: breakdown && breakdown.registered_invites,
                        id: 'registered-invites',
                    },
                    {
                        h: 'Expired Invites',
                        c: breakdown && breakdown.expired_invites,
                        id: 'expired-invites',
                    },
                ].map((value) => (
                    <PreviewTile
                        title={value.h}
                        text={String(value.c)}
                        key={value.h}
                        id={value.id}
                    />
                ))}
            </Grid>
        </>
    )
}

export default InvitesOverview
